import app from "flarum/forum/app";
const tracked = new Set();
export default function observeBanners(root) {
  if (typeof IntersectionObserver === "undefined") return () => {};
  const timers = new Map();
  const visible = new Set();
  const cancel = element => {
    const timer = timers.get(element);
    if (timer !== undefined) clearTimeout(timer);
    timers.delete(element);
  };
  const schedule = element => {
    const id = element.getAttribute("data-banner-id");
    if (!id || tracked.has(id) || timers.has(element) || document.hidden) return;
    timers.set(element, setTimeout(() => {
      timers.delete(element);
      if (!element.isConnected || document.hidden || !visible.has(element)) return;
      tracked.add(id);
      void fetch(app.forum.attribute("apiUrl") + "/banners/impressions", {
        method: "POST",
        credentials: "same-origin",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": app.session.csrfToken
        },
        body: JSON.stringify({
          ids: [Number(id)]
        })
      }).catch(() => {});
      observer.unobserve(element);
    }, 1000));
  };
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.8) {
        visible.add(entry.target);
        schedule(entry.target);
      } else {
        visible.delete(entry.target);
        cancel(entry.target);
      }
    }
  }, {
    threshold: [0, 0.8, 1]
  });
  const onVisibility = () => {
    visible.forEach(element => {
      if (document.hidden) cancel(element);else schedule(element);
    });
  };
  root.querySelectorAll("[data-banner-id]").forEach(element => observer.observe(element));
  document.addEventListener("visibilitychange", onVisibility);
  return () => {
    observer.disconnect();
    timers.forEach(timer => clearTimeout(timer));
    document.removeEventListener("visibilitychange", onVisibility);
  };
}